import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  bootstrapLoadError: {
    id: 'app.inventory.bootstrap.loadError',
  },
  bootstrapMissingBackendId: {
    id: 'app.inventory.bootstrap.missingBackendId',
  },
  bootstrapNoCachedOffline: {
    id: 'app.inventory.bootstrap.noCachedOffline',
  },
  bootstrapRefreshError: {
    id: 'app.inventory.bootstrap.refreshError',
  },
});
